import { useCallback, useState } from "react"
import { useMutation } from "react-relay"
import {
  AddressInput,
  chFindClosestPreventionCareProviderMutation as ChFindClosestPreventionCareProviderMutationType,
} from "@/modules/patients/detail/progress-note/services/__generated__/chFindClosestPreventionCareProviderMutation.graphql"
import { chFindClosestPreventionCareProviderMutation } from "@/modules/patients/detail/progress-note/services/chFindClosestPreventionCareProviderMutation"

type UseFindClosestPreventionCareProviderResult = {
  findClosestCareProvider: (params: {
    patientId: string
    address: AddressInput
    preventionProgramKey: string
  }) => Promise<string | null>
  isLoading: boolean
}

export const useFindClosestPreventionCareProvider = (): UseFindClosestPreventionCareProviderResult => {
  const [isLoading, setIsLoading] = useState(false)

  const [commit] = useMutation<ChFindClosestPreventionCareProviderMutationType>(
    chFindClosestPreventionCareProviderMutation,
  )

  const findClosestCareProvider = useCallback(
    ({
      patientId,
      address,
      preventionProgramKey,
    }: {
      patientId: string
      address: AddressInput
      preventionProgramKey: string
    }) =>
      new Promise<string | null>((resolve) => {
        setIsLoading(true)
        commit({
          variables: {
            input: {
              patientId,
              address,
              preventionProgramKey,
            },
          },
          onCompleted: (response) => {
            setIsLoading(false)
            const output = response.ch_findClosestPreventionCareProvider.findClosestPreventionCareProviderOutput
            resolve(output?.closestCareProviderId ?? null)
          },
          onError: () => {
            setIsLoading(false)
            resolve(null)
          },
        })
      }),
    [commit],
  )

  return { findClosestCareProvider, isLoading }
}
